import apiUrl from '../../../constants'
import axios from 'axios'
import Outbound from './Outbound/index.vue';
import OutboundPendency from './OutboundPendency/index.vue';
import Inbound from './Inbound/index.vue';


export default {
  name: 'AutoHandover',
  components: {
    'first': Outbound,
    'middle': OutboundPendency,
    'third': Inbound
  },
  props: [],
  data() {
    return {
      currentTab: 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'Outbound'
        },
        {
          key: 'Middle',
          value: 'Outbound Pendency'
        },
        {
          key: 'Third',
          value: 'Inbound'
        }
      ],
    }
  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  mounted() {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/AutoHandover_v1/AutoHandover_v1.js